
$(document).ready(function($) {

    const homeHero = new Swiper('.heroSwiper', {
        speed: 1200,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        //autoplay: {
        //    delay: 5000,
        //},
        pagination: {
            el: '.swiper-pagination',
            type: "fraction",
            clickable: true,
        },
    });

    const featureSlider = new Swiper(".featureslideSwiper", {
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
          768: {
              slidesPerView: 2,
              spaceBetween: 24,
          },
          1024: {
              slidesPerView: 2.5,
              spaceBetween: 24,
          },
          1200: {
              slidesPerView: 3,
              spaceBetween: 32,
          },
          1600: {
              slidesPerView: 3,
              spaceBetween: 48,
          },
        },
        scrollbar: {
          el: ".feature-scrollbar",
          draggable: true,
        },
      });

      var swiper = new Swiper(".gallery-swiper", {
        speed: 1200,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        //autoplay: {
        //    delay: 5000,
        //},
        pagination: {
            el: '.swiper-pagination',
            type: "fraction",
            clickable: true,
        },
      });

      var colSwiper = new Swiper(".image-slider", {
        speed: 1200,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        //autoplay: {
        //    delay: 5000,
        //},
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    });